import { zodResolver, type PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import { BlockedRecordExamPasserSchema, type BlockedRecordExamPasserFormType } from './schema';

interface BlockedRecordExamPasserFormProviderProps extends PropsWithChildren {
  initialValues: BlockedRecordExamPasserFormType;
}

export default function BlockedRecordExamPasserFormProvider(
  props: Readonly<BlockedRecordExamPasserFormProviderProps>,
) {
  const { initialValues, children } = props;

  const formContext = useForm<BlockedRecordExamPasserFormType>({
    resolver: zodResolver(BlockedRecordExamPasserSchema),
    defaultValues: initialValues,
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
